import React from 'react'
import { useGetPermissions } from '../../../../layouts/customHook';
import { PermisionDenied } from '../../../../views/pages/manage/common/commonComponents';
import PMApprovalConfigListing from './PMApprovalConfigListing';


const PmApprovalConfigPage = () => {
    const userPermissions = useGetPermissions('paymentManagementApprovalConfig');
    return userPermissions ? <PMApprovalConfigListing userPermissions={userPermissions} /> : <PermisionDenied />

}

export default PmApprovalConfigPage;